import { SimpleSaleReturnView } from "@medicorepay/ui";
import { useNavigate, useSearchParams } from "react-router-dom";
import { productRevivalApi } from "../../services/product-revival-client";
import { useAuthStore } from "../../stores/authStore";
import apiClient from "../../lib/api-client";

export function CreateSalesReturnPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialInvoiceNumber = searchParams.get("invoiceNumber") ?? undefined;
  const storeId =
    useAuthStore((state) => state.selectedStoreId) ||
    useAuthStore((state) => state.user?.storeId) ||
    "active-store";

  return (
    <SimpleSaleReturnView
      getReturnableSale={(invoiceNumber) =>
        productRevivalApi.getReturnableSale(invoiceNumber)
      }
      createSaleReturn={(body, idempotencyKey) =>
        productRevivalApi.createSaleReturn(body, {
          idempotencyKey,
          clientApplication: "web",
        })
      }
      requestManagerApproval={async (body, idempotencyKey) =>
        (
          await apiClient.post(
            "/product-revival/sales/returns/manager-approval-requests",
            body,
            { headers: { "Idempotency-Key": idempotencyKey } },
          )
        ).data
      }
      getManagerApproval={async (approvalRequestId) =>
        (
          await apiClient.get(
            `/security/approvals/${encodeURIComponent(approvalRequestId)}`,
          )
        ).data
      }
      onBack={() => navigate("/sales-returns")}
      initialInvoiceNumber={initialInvoiceNumber}
      idempotencyScope={storeId}
    />
  );
}
